import React from 'react';
import styled from 'styled-components';
import { Box, Container } from '@landr/maestro';
import { MainNavigation } from 'components/Navigations';
import Wrapper from 'components/CommonUi/Wrapper';
import useAppNavigationMeta from 'hooks/useAppNavigationMeta/useAppNavigationMeta';
import { UniversalNavBar } from 'components/Navigations/UniversalNavBar/UniversalNavBar';
import { zIndex } from '../../../constants';

const ZIndexWrapper = styled(Box)`
    z-index: ${zIndex.mainNavigation};
`;

const AppNavigation: React.FC = () => {
    const { isUnbAllowed } = useAppNavigationMeta();

    return (
        <>
            {isUnbAllowed && <UniversalNavBar />}
            <ZIndexWrapper>
                <Wrapper>
                    <Container>
                        <MainNavigation />
                    </Container>
                </Wrapper>
            </ZIndexWrapper>
        </>
    );
};

export default AppNavigation;
